import { useTranslation } from 'react-i18next';
import { EntityDirectorySelectFilter } from '../shared/entityDirectory/EntityDirectorySelectFilter';

interface SupplierTypeFilterProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
}

export function SupplierTypeFilter({
  value,
  onChange,
}: SupplierTypeFilterProps) {
  const { t } = useTranslation();

  return (
    <EntityDirectorySelectFilter
      options={[
        { label: t('suppliers.internal'), value: true },
        { label: t('suppliers.external'), value: false },
      ]}
      placeholder={`${t('suppliers.type')}: ${t('filter.all')}`}
      value={value}
      onChange={(selectedValue) => onChange(selectedValue ?? undefined)}
    />
  );
}
